import { useSharedAuth } from '@src/context/auth/useSharedAuth';
import { useCallback, useEffect, useRef, useState } from 'react';

export const useReactionLoginAlertTooltip = (duration = 3000) => {
  const [isVisible, setIsVisible] = useState(false);
  const { profile } = useSharedAuth();
  const isLoggedIn = profile?.companyProfile?.isLogin ?? profile?.tenantProfile?.isLogin;
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const showTooltipIfNotLoggedIn = useCallback(() => {
    if (!isLoggedIn) {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }

      setIsVisible(true);

      timeoutRef.current = setTimeout(() => {
        setIsVisible(false);
        timeoutRef.current = null;
      }, duration);

      return true;
    }
    return false;
  }, [isLoggedIn, duration]);

  const hideTooltip = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
    setIsVisible(false);
  }, []);

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return {
    isLoggedIn,
    isTooltipVisible: isVisible,
    showTooltipIfNotLoggedIn,
    hideTooltip,
  };
};
